import { render, staticRenderFns } from "./SubmissionFeedReport.vue?vue&type=template&id=651af0e0"
import script from "./SubmissionFeedReport.vue?vue&type=script&lang=js"
export * from "./SubmissionFeedReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports